import React, { useState } from 'react';
import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';
import { IBaseInventoryItem } from 'components/kitchen/inventory-base-meal-item/types';

type Props = {
  show: boolean;
  onClose: (success?: boolean) => void;
  meal: IBaseInventoryItem;
  type: 'add' | 'reduce';
  onConfirm: (arg0: { quantity: string; note: string }) => void;
};

type DeleteStaffModalFooterProps = {
  loading: boolean;
  disabled: boolean;
  onConfirm: () => void;
};

const UpdateBaseMealQuantityModalFooter = ({
  loading,
  onConfirm,
  disabled
}: DeleteStaffModalFooterProps) => {
  return (
    <div className='w-full mt-4 gap-8'>
      <Button
        onClick={onConfirm}
        className='bg-red-5 hover:bg-red-6 text-white'
        small
        variant='block'
        color='primary'
        disabled={disabled}
        loading={loading}>
        Confirm
      </Button>
    </div>
  );
};
const UpdateBaseMealQuantityModal = ({ show, onClose, meal, type, onConfirm }: Props) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ quantity: '', note: '' });
  const updateQuantity = async () => {
    setLoading(true);
    try {
      const res = await apiService.put(`base-meal-quantity/${meal?.id}`, {
        baseUrl: process.env.REACT_APP_BRAND_MGT_API_URL,
        data: {
          quantity: form.quantity,
          action: type === 'reduce' ? 'reduced' : 'produced',
          reason: form?.note
        }
      });
      if (res.status === 200) {
        onConfirm(form);
        onClose(true);
        toast(
          <ToastMessage type='success' message={`${meal.base_meal?.name} updated successfully`} />
        );
        setForm({ quantity: '', note: '' });
      }
    } catch (error: any) {
      onClose();
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      bodyOpenClassName={'hide_title_icon'}
      isOpen={show}
      onRequestClose={() => {
        onClose();
        setForm({ quantity: '', note: '' });
      }}
      title={`${type === 'add' ? 'Add' : 'Reduce'} ${meal?.base_meal?.name} `}
      titleIcon={<ErrorIcon />}
      titleIconColor='danger'
      footer={
        <UpdateBaseMealQuantityModalFooter
          disabled={Number(form?.quantity) === 0 || !form?.note}
          loading={loading}
          onConfirm={updateQuantity}
        />
      }>
      <div className='flex flex-col justify-center items-center gap-y-4'>
        <Input
          inputClass='h-[45px] placeholder:text-sm text-sm'
          label={'Quantity*'}
          onChange={(e) => setForm({ ...form, quantity: e.target.value })}
          value={form?.quantity}
          name={'quanity'}
          placeholder={'0'}
          disabled={loading}
          type='text'
        />
        <Input
          inputClass='h-[85px] placeholder:text-sm text-sm'
          label={'Add note*'}
          onChange={(e) => setForm({ ...form, note: e.target.value })}
          value={form?.note}
          name={'quanity'}
          placeholder={'Reason for addition'}
          disabled={loading}
          type='text'
        />
      </div>
    </BaseModal>
  );
};

export default UpdateBaseMealQuantityModal;
